<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">MasterBranch Summary</div>
        <div>
          <bread-crumb :bread-crumbs="['MasterBranch Summary']" />
        </div>
      </v-card-title>

      <v-data-table
        fixed-header
        height="55vh"
        :headers="dessertHeaders"
        :items="BranchSummary"
        :search="search"
        item-key="name"
        dense
      >
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-btn
              depressed
              x-small
              @click="openBlockDialog(item)"
              color="success"
              title="Unblock user"
              class="text-capitalize me-3"
              v-if="item.is_active"
            >
              Active
            </v-btn>
            <v-btn
              depressed
              x-small
              @click="openBlockDialog(item)"
              color="warning"
              class="text-capitalize me-3"
              title="Block user"
              v-else
            >
              Block
            </v-btn>
            <v-icon
              small
              title="Edit"
              color="primary"
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-content-save-edit-outline
            </v-icon>
          </div>
          <!-- <v-badge color="grey" content="1" small shape="circle"> -->
        </template>

        <template v-slot:top>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <div class="d-flex mt-5">
            <v-btn
              depressed
              small
              class="text-capitalize me-3 ms-2 mt-2 text-decoration-none"
              color="primary"
              @click="openDialog"
              ><v-icon small class="me-2">mdi-branch</v-icon>Add Branch</v-btn
            >
            <v-form ref="form" v-model="valid" lazy-validation class="d-flex">
              <v-file-input
                v-model="bankBranch"
                class="rounded"
                :class="!webbreakdown() ? 'fileinput' : ''"
                outlined
                dense
                accept=".xlsx"
                placeholder="Browse File"
                :rules="FieldRequired('File')"
                @change="uploadFileBankBranches()"
              ></v-file-input>

              <a
                href="/sample_bank_branch_template.xlsx"
                class="text-subtitle-1 mx-2"
                download
              >
                <v-icon color="primary">mdi-download</v-icon>Sample Excel File
                <v-icon color="primary" small>mdi-file-excel</v-icon>
              </a>
            </v-form>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="me-3 mt-2"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-5"
              dense
              clearable
            ></v-text-field>
          </div>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showDialog" width="600">
        <v-card>
          <v-form ref="Addform" v-model="valid">
            <v-toolbar color="secondary" dark flat dense>
              <span>{{ formtitle }} Branch Details</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Branch Name
                  </label>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    placeholder="Branch Name"
                    :rules="branchNameRules"
                    v-model="branchDetails.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Branch Code
                  </label>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    placeholder="Branch Code"
                    :rules="branchCodeRules"
                    v-model="branchDetails.branch_code"
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Country
                  </label>
                  <v-autocomplete
                    class="rounded"
                    dense
                    outlined
                    placeholder="Country"
                    item-text="text"
                    item-value="value"
                    :rules="countryRules"
                    :items="dropdown.countryOptions"
                    @change="getStates()"
                    v-model="branchDetails.country"
                  ></v-autocomplete>
                </v-col> -->
                <v-col cols="12" md="12" v-if="hideData">
                  <label class="my-0 rounded labelFontsize"> State </label>
                  <v-autocomplete
                    class="rounded"
                    dense
                    outlined
                    placeholder="State"
                    item-text="text"
                    item-value="values"
                    @change="getCities(true)"
                    :items="dropdown.state_options"
                    v-model="branchDetails.state"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12" v-if="hideData">
                  <label class="my-0 rounded labelFontsize"> City </label>
                  <v-autocomplete
                    v-if="!cityInputEnabled"
                    class="rounded"
                    dense
                    outlined
                    placeholder="City"
                    :items="dropdown.city_options"
                    item-text="text"
                    item-value="values"
                    v-model="branchDetails.city"
                  ></v-autocomplete>
                  <v-text-field
                    v-else
                    class="rounded"
                    dense
                    outlined
                    placeholder="Enter City"
                    v-model="branchDetails.city"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Phone Number
                  </label>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    placeholder="Phone Number"
                    hide-spin-buttons
                    @keydown="nodotNumber"
                    :rules="phoneNumberRules"
                    v-model="branchDetails.phone_number"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <label class="my-0 rounded labelFontsize required">
                    Address
                  </label>
                  <v-textarea
                    class="rounded"
                    dense
                    outlined
                    rows="2"
                    placeholder="Address"
                    :rules="addressRules"
                    v-model="branchDetails.address"
                  ></v-textarea>
                </v-col>

                <div
                  class="col-md-12"
                  style="display: flex; justify-content: right; margin-top: 8px"
                >
                  <v-btn
                    depressed
                    color="primary"
                    min-width="170px"
                    class="me-5 text-capitalize"
                    @click="onSubmitFor()"
                  >
                    {{ branchDetails.branch_id ? "Update" : "Add" }}
                  </v-btn>

                  <v-btn
                    depressed
                    color="primary"
                    class="text-capitalize"
                    outlined
                    min-width="170px"
                    @click="closeDialog()"
                  >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon>
                    Cancel
                  </v-btn>
                </div>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="showBlockDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom"
            >Update Branch Status</v-card-title
          >
          <v-card-text class="h5 py-3"
            >Are you sure you want to {{ title_text }}?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="confirmBlock(isActive ? false : true)"
            >
              {{ title_text }}<v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="showBlockDialog = false"
            >
              Close<v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="branchSummaryDialog" width="500">
        <v-card class="pa-0">
          <v-toolbar color="seocondary" dark flat dense>
            <span>Branch Summary </span>
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="branchSummaryDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="mt-4">
            <div class="d-flex justify-center">
              <div class="h5 mx-2">
                Success:<span class="text-success">{{
                  summaryBranch.success
                }}</span>
              </div>
              <div class="h5 mx-2">
                Failure:<span class="text-danger">{{
                  summaryBranch.failed
                }}</span>
              </div>
              <div class="h5 mx-2">
                Total:<span>{{ summaryBranch.total }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
import setupService from "@/services/SetupService/setupService";
import commonService from "@/services/CommonService/commonService.js";
import { masterBankandBranch } from "@/utils/validation.js";
import { FieldRequired } from "@/utils/validation.js";
// import { nodotNumber } from "@/utils/validate.js";
import { webbreakdown } from "../../../utils/breakpoints";
export default {
  mixins: [alerts],
  name: "MasterBranch Summary",
  data() {
    return {
      webbreakdown,
      ...masterBankandBranch,
      // ...nodotNumber,
      // expanded: [],
      FieldRequired,
      search: "",
      branchSummaryDialog: false,
      bankBranch: null,
      dialogDelete: false,
      isActive: null,
      branch_id: null,
      loader: false,
      showDialog: false,
      showBlockDialog: false,
      valid: true,
      editedIndex: -1,
      title_text: "",
      country_code: "",
      hideData: true,
      dessertHeaders: [
        {
          text: "Branch Id",
          sortable: false,
          value: "branch_id",
        },
        { text: "Branch Name", value: "name" },
        { text: "Branch Code", value: "branch_code" },
        { text: "Address", value: "address" },
        { text: "Action", value: "action", sortable: false },
      ],
      BranchSummary: [],
      cityInputEnabled: false,
      summaryBranch: {},
      branchDetails: {
        name: "",
        bank_id: null,
        branch_code: "",
        phone_number: null,
        std_code: "",
        state: "",
        city: "",
        address: "",
        swift_bank: "",
      },
      dropdown: {
        countryOptions: [],
        state_options: [],
        city_options: [],
        country_objs: [],
      },
    };
  },
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  mounted() {
    this.country_code = this.$route.query.country;
    this.getcountryList();
    this.getStates();
    if (this.$route.query.bank_id) {
      this.getAllBranches();
    }
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  methods: {
    async downloadExcelsheet() {
      if (this.BranchSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.BranchSummary,
          "branchSummary"
        );
      }
    },

    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async uploadFileBankBranches() {
      const valid = this.$refs.form.validate();
      if (valid) {
        this.loader = true;
        console.log(this.bankBranch);
        const fileData = new FormData();
        fileData.append("document", this.bankBranch);
        console.log(fileData);
        try {
          this.loader = true;
          const response = await setupService.uploadFileBankBranches(
            this.$route.query.bank_id,
            fileData
          );

          if (response.data && response.data.status_code === 200) {
            this.loader = false;
            this.branchSummaryDialog = true;
            this.summaryBranch = response.data.data[0];
            this.showAlertSuccess(response.data.message);
            this.getAllBranches();
          } else {
            this.showAlertError(response.data.message);
            this.loader = false;
          }
        } catch (error) {
          this.showAlertError("Something went wrong");
          this.loader = false;
          console.log(error);
        }
      }
    },

    async getAllBranches() {
      try {
        const response = await setupService.getAllBranches(
          this.$route.query.bank_id
        );
        this.loader = true;
        if (response.data.status_code === 200) {
          this.BranchSummary = response.data.data.reverse();
          console.log(this.BranchSummary);
          this.stoploader();
        } else if (response.data.status_code === 401) {
          this.BranchSummary = [];
        } else {
          this.stoploader();
          this.showAlertError(`Failed: ${response.data.message}`);
          this.BranchSummary = [];
        }
        console.log("All Banks", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
        this.BranchSummary = [];
      }
    },

    onSubmitFor() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.branchDetails.branch_id) {
          this.update();
        } else {
          this.save();
        }
      }
    },

    async save() {
      this.branchDetails.bank_id = this.$route.query.bank_id;
      try {
        const response = await setupService.AddBranchData(this.branchDetails);
        this.loader = true;
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.getAllBranches();
          this.showDialog = false;
          this.stoploader();
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.save();
        // }
        else {
          this.showAlertError(response.data.message);
          this.loader = false;
        }
        console.log("saved Data", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
      }
    },
    async update() {
      try {
        const response = await setupService.updateBranchData(
          this.branchDetails.branch_id,
          this.branchDetails
        );
        this.loader = true;
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.getAllBranches();
          this.showDialog = false;
          this.stoploader();
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.save();
        // }
        else {
          this.showAlertError(response.data.message);
          this.loader = false;
        }

        console.log("update Data", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
      }
    },
    openDialog() {
      this.resetBranchObj();
      this.showDialog = true;
      this.editedIndex = -1;
      if (this.$refs.Addform) {
        this.$refs.Addform.resetValidation();
      }
    },
    resetBranchObj() {
      this.branchDetails = {};
    },

    editItem(item) {
      this.editedIndex = 1;
      this.getBranchById(item.branch_id);
      this.branchDetails.state = item.state;
      this.getStates();
      this.getCities();
      this.showDialog = true;
    },

    async getBranchById(id) {
      this.hideData = false;
      try {
        const response = await setupService.getBranchById(id);
        this.loader = true;
        if (response.data.status_code === 200) {
          this.branchDetails = response.data.data[0];
          this.branchDetails.state = response.data.data[0].state.toUpperCase();
          this.stoploader();
        } else {
          this.stoploader();
          this.showAlertError(`Failed: ${response.data.message}`);
        }
        console.log("Branch", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
      }
    },

    closeDialog() {
      this.editedIndex = -1;
      this.showDialog = false;
      this.hideData = true;
      this.$refs.Addform.reset();
    },
    navBranchList() {
      this.$router.push({ name: "" });
    },
    openBlockDialog(item) {
      console.log(item);
      this.title_text = item.is_active ? "Block" : "Active";
      this.showBlockDialog = true;
      this.branch_id = item.branch_id;
      this.isActive = item.is_active;
    },
    async confirmBlock(is_active) {
      this.loader = true;
      try {
        const response = await setupService.updateBranchStatus(
          this.branch_id,
          is_active
        );
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.getAllBranches();
          this.showBlockDialog = false;
          this.stoploader();
        } else {
          this.showAlertError(response.data.message);
          this.loader = false;
        }
        console.log("update Data", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
      }
    },
    async getcountryList() {
      try {
        const response = await setupService.getCountrysetupList();
        if (response.status === 200) {
          this.dropdown.countryOptions = response.data.data.map((i) => {
            return { text: i.name, value: i.iso_alpha3 };
          });
          this.dropdown.country_objs = response.data.data;
        }
        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },
    async getStates() {
      try {
        const response = await commonService.getStatesList(this.country_code);
        if (response.status === 200) {
          this.dropdown.state_options = response.data.data.map((i) => {
            return { text: i.name, values: i.state_code };
          });
        }

        console.log("States", response);
      } catch (e) {
        this.dropdown.state_options = [];
        console.error(e);
      }
    },

    async getCities(resetSelection = false) {
      if (resetSelection) this.branchDetails.city = "";
      this.cityInputEnabled = false;
      this.dropdown.city_options = [];
      try {
        const response = await commonService.getCitiesList(
          this.country_code,
          this.branchDetails.state
        );
        console.log("cities", response);
        if (response.status === 200) {
          this.dropdown.city_options = response.data.data.map((i) => {
            return { text: i.name, values: i.name, id: i.id };
          });
          this.cityInputEnabled = this.dropdown.city_options.length === 0;
        } else {
          this.dropdown.city_options = [];
        }
        console.log("company_city", response);
      } catch (error) {
        this.dropdown.city_options = [];
        console.error("Error fetching :", error);
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
.fileinput {
  width: 400px;
}
</style>
